module.exports = __webpack_public_path__ + "static/media/Stellar King Hydraulic Bed Base - 180x210 cm.27aebcc6.jpg";